import { render, staticRenderFns } from "./UserPreRegistration.vue?vue&type=template&id=2d60e74a&"
import script from "./UserPreRegistration.vue?vue&type=script&lang=js&"
export * from "./UserPreRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports